/**
 * Active picking-queue count in the terminal: render once we have a numeric value (including 0); suffix is "batch"/"batches" (EN) or wave forms (RU).
 */

export function shouldShowActiveQueueCount (raw) {
  if (raw === undefined || raw === null) {
    return false
  }
  const n = Number(raw)
  return !Number.isNaN(n)
}

function ruWaveForm (n) {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) {
    return 'волна'
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return 'волны'
  }
  return 'волн'
}

/**
 * @param {number} n — positive count
 * @param {string} locale — vue-i18n locale
 * @param {(key: string) => string} t — $t
 */
export function activeQueueCountSuffix (n, locale, t) {
  const num = Number(n)
  const loc = String(locale || '').toLowerCase()
  if (loc.startsWith('ru')) {
    return ruWaveForm(num)
  }
  return num === 1
    ? t('terminal.queue.batchSingular')
    : t('terminal.queue.batchPlural')
}
